import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import {
  clearUserSession,
  getActorData,
  getUserData,
  hasActiveUserSession,
  isValidAccessToken,
} from "../utils/auth-helpers";

/**
 * Guard for authProtectedRoutes / authEditorRoutes.
 * Requires userType=user + non-expired JWT. Unset userType must NOT bypass auth
 * (that previously allowed open access to dashboard without login).
 */
export const Authmiddleware = ({ children, roles, location }) => {
  const userType = localStorage.getItem("userType");

  if (userType === "actor") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!hasActiveUserSession()) {
    if (
      localStorage.getItem("token")
      || localStorage.getItem("userdata")
      || localStorage.getItem("accountId")
      || userType === "user"
    ) {
      clearUserSession();
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const role = getUserData()?.role;
  if (roles && role && !roles.includes(role)) {
    // Role mismatch: keep session but stay on route (legacy behaviour).
  }

  return <>{children}</>;
};

export const ActorAuthmiddleware = ({ children, roles, location }) => {
  const userType = localStorage.getItem("userType");
  const token = localStorage.getItem("actorToken");

  if (userType !== "actor" || !isValidAccessToken(token)) {
    if (userType === "actor" || token) {
      clearUserSession();
    }
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export const ActorPublicAuthMiddleware = ({ children, location }) => {
  const userType = localStorage.getItem("userType");

  // 🚫 Skip actor middleware if it's not an actor session
  if (userType !== "actor") return <>{children}</>;

  const token = localStorage.getItem("actorToken");
  const actorData = getActorData();
  const consent = actorData?.user?.consent;

  let campaignId, actorId;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      campaignId = decoded?.campaign_id;
      actorId = decoded?.actor_id;
    } catch (err) {
      console.error("Invalid JWT token", err);
    }

    if (consent) {
      if (campaignId && actorId) {
        return (
            <Navigate
                to={`/campaign-table/${campaignId}/videos/${actorId}`}
                state={{ from: location }}
            />
        );
      } else {
        return <Navigate to="/error" state={{ from: location }} />;
      }
    } else {
      return <Navigate to="/actor-form" state={{ from: location }} />;
    }
  }

  return <>{children}</>;
};
